import { BaseTabelaPDF, helperPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaPosicaoConsolidadaPDF(props) {
    const { layout = 'default', theme, rows, firstColWidth, useLegendColor, datas, headerPercent } = props;
    let columns = getLayouts(datas, headerPercent)[layout];
    const generateStyle = (cell) => {
        if (cell.bgColor) {
            const styles = {
                textColor: cell.color,
                fillColor: cell.bgColor,
                bold: cell.bold
            };
            return styles;
        }
        else {
            return {};
        }
    };
    let body = null;
    if (useLegendColor) {
        body = helperPDF.gerarBodyComCor(rows, columns, theme, 2, 1, undefined, undefined, generateStyle);
        columns = ['', ...columns];
    }
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { columns, tableConfig: {
            body,
            halign: 'center',
            valign: 'middle',
            bodyGenerateStyle: generateStyle,
            minCellHeight: 0,
            cellWidth: firstColWidth
        }, useHeaderStyle: true }));
}
